/**
 * Subscription Product — Pattern Card UI Enhancement
 *
 * theme.Variants クラスが data-variant-input の change イベントを
 * 自動的にリッスンしているため、バリアント切り替え自体は追加コード不要。
 * このファイルは画像カードの補助的なUI強化を担当。
 */
(function() {
  'use strict';

  /**
   * 硬さパターン画像の読込エラー時のフォールバック処理
   * onerror 属性に加えて、JS側でもカバーする
   */
  function initPatternImageFallback() {
    var images = document.querySelectorAll('.pattern-card__image img');
    images.forEach(function(img) {
      if (img.complete && img.naturalWidth === 0) {
        img.style.display = 'none';
      }
      img.addEventListener('error', function() {
        this.style.display = 'none';
      });
    });
  }

  /**
   * 在庫切れバリアントの pattern-card を disabled 表示にする
   * variant-picker-subscription.liquid は options.size == 1 の場合のみ
   * available チェックしているが、複数オプション時の組み合わせ在庫切れは
   * theme.Variants の variantChange イベントで動的に制御する
   */
  function initDisabledStateSync() {
    var productSections = document.querySelectorAll('[data-section-type="product"]');
    productSections.forEach(function(section) {
      section.addEventListener('variantChange', function(evt) {
        if (!evt.detail || !evt.detail.variant) return;
        // variantChange 時に追加のUI制御が必要な場合ここに記述
      });
    });
  }

  // DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initPatternImageFallback();
      initDisabledStateSync();
    });
  } else {
    initPatternImageFallback();
    initDisabledStateSync();
  }
})();
